<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      СНиП 3.04.03-85<br>
      <br>
      Приложение 1<br>
      обязательное
    </div>
    <div class="chapter-title">ЖУРНАЛ ПРОИЗВОДСТВА АНТИКОРРОЗИОННЫХ РАБОТ</div>
    <n-items v-if="project">
      <n-button v-if="checkSign()" @click="$var('corrected', true)">Подписать</n-button>
      <n-input title="Наименование объекта" v-bind="$form.input('title')" :text="!editable" />
      <n-input title="Основание для выполнения работ (договор, наряд)" v-bind="$form.input('work')" :text="!editable" />
      <n-input title="Производитель работ" v-bind="$form.input('executor')" :text="!editable" />
      <n-datepicker title="Начало " v-bind="$form.input('startedAt')" :text="!editable" />
      <n-datepicker title="Окончание" v-bind="$form.input('endedAt')" :text="!editable" />
      <div>Подпись администрации организации, выдавшей журнал</div>
      <c-journal-sign :sign="getSign(journal, 'author')" /><br>
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
    <c-modal-journal-do-sign v-if="$var('corrected')" @close="$var('corrected', false)" @submit="(s) => doSign('author', s)" />
  </div>
</template>

<script>
import CModalJournalDoSign from '../../../components/journal/ModalDoSign'
import CJournalSign from '../../../components/journal/Sign'

export default {
  name: 'MainChapter1',
  components: { CModalJournalDoSign, CJournalSign, },
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    checkSign() {
      return this.journal.data.userId === $app.auth.user().id && this.getSign(this.journal, 'author').isApproved !== true
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
    doSign(name, sign) {
      this.$var('load', true)
      $api.journals.spec55.doSign(this.journal.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
